
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { ComparativeSampleDataMixin } from '@/mixins/ComparativeSampleDataMixin';
import { VuetifyMixin, BAIconsMixin } from '@/mixins';
import ComparativeDataNoComparisonAlert from '@/components/profile/athlete/ComparativeDataNoComparisonAlert.vue';
import { ComparativeDataPageState } from '@/models/pageStates/ComparativeDataPageState';

@Component({
	components:{
		ComparativeDataNoComparisonAlert,
	}
})
export default class ManageSampleDataDialog extends Mixins(
	VuetifyMixin,
	ComparativeSampleDataMixin,
	BAIconsMixin
) {
	@Prop({ required: true }) state: ComparativeDataPageState;
}
